import { render, staticRenderFns } from "./PlatformOrderDetail.vue?vue&type=template&id=0c8e4fbc"
import script from "./PlatformOrderDetail.vue?vue&type=script&lang=js"
export * from "./PlatformOrderDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports